import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './preview.css';
import printLogo from '../imgs/print-logo.png';
import hujulin from '../imgs/hujulin.png';
import { getSex, formatDA, getImageWithToken } from '../utils';

class PrintReport extends Component {
  static propTypes = {
    server: PropTypes.object,
    report: PropTypes.object,
    printDicomId: PropTypes.string,
    match: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const roleInfo = window.store.getState().api.user.info.operationAuths || '';
    const isAnonymity = roleInfo.indexOf('S') >= 0;
    this.state = {
      dicomId: props.match.params.dicomId,
      uploadType: props.match.params.uploadType,
      report: this.props.report || {},
      imgHtml: [],
      isAnonymity,
    };
  }

  static propTypes = {
    history: PropTypes.object,
  };

  componentDidUpdate(prevProps) {
    if (this.props.report !== prevProps.report) {
      this.setState({ report: this.props.report });
      this.getImgs(this.props.report);
    }
  }
  componentDidMount() {
    this.getImgs();
  }
  getImgs = result => {
    const report = result || this.state.report;
    const imgList = report.imgList || [];
    const len = imgList.length;
    if (len <= 0) return;
    const imgHtml = [];
    imgList.map((item, index) => {
      let url = `/v1/picl/aets/piclarc/rs/studies/${item.studyUid}/series/${item.seriesUid}/instances/${item.sopInstanceId}/frames/1/rendered`;
      imgHtml.push(
        <span id={`print-img${index}`} key={index}>
          {getImageWithToken(url, `print-img${index}`, len)}
        </span>
      );
      return null;
    });
    this.setState({ imgHtml });
  };
  render() {
    const { report, imgHtml, isAnonymity } = this.state;
    report.record = report.record || {};
    if (report) {
      return (
        <div className="preview-report">
          <div className="title">
            {report.record.institutionId === 107 ? (
              <>
                <p className="title-1">江西省胸科医院肺结核AI筛查报告</p>
                <p className="title-2">-九峰医疗提供技术支持</p>
              </>
            ) : (
              <>
                <p className="title-1">{report.record.institutionName}</p>
                <p className="title-2">肺结核筛查报告</p>
              </>
            )}
          </div>
          <div className="institution">
            <p>送检机构：{report.record.institutionName}</p>
            <p>检查日期：{formatDA(report.record.createTime)}</p>
          </div>
          <div className="user-info">
            <span>姓名：{isAnonymity ? '***' : report.record.patName}</span>
            <span>性别：{getSex(report.record.patSex)}</span>
            <span>年龄：{report.record.patAge}</span>
          </div>
          <div className="user-info">
            <span>影像号：{}</span>
            <span>就诊卡号：{}</span>
            <span>住院号：{}</span>
          </div>
          <div className="user-info">
            <span>床位号：{}</span>
            <span>检查号：{}</span>
            <span></span>
          </div>
          <div className="preview-img">{imgHtml}</div>
          <div className="preview-content">
            <p className="title">影像所见</p>
            <div className="content"></div>
          </div>
          <div className="preview-content">
            <p className="title">AI辅助诊断参考意见</p>
            <div className="content">{report.templateReport}</div>
          </div>
          <div className="preview-content">
            <p className="title">诊断建议</p>
            <div className="content">
              <p>{report.doctorVerifyCodeToText}</p>
              <p>{report.doctorRemark}</p>
            </div>
          </div>
          <div className="printer-footer">
            {report.record.institutionId === 107 ? (
              <>
                <div className="printer-review">
                  审核医生：
                  <img className="print-name" alt="" src={hujulin} />
                  <span>审核时间：{report.record.updateTime}</span>
                </div>
                <div className="printer-tip">
                  注：此报告仅对上述检查项目提供诊断信息，仅供临床医生诊断参考，不作其它用途。
                </div>
              </>
            ) : (
              <div>
                <img className="print-logo" alt="" src={printLogo} />
                <span className="print-time">
                  打印日期：{formatDA(new Date())}
                </span>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default withRouter(PrintReport);
